import React, { Component } from 'react';
import BG_NORMAL from '../images/booth_blank.png';
import CUSTOM_BG from '../images/custom_bg.jpg';
import EMPTY_BG from '../images/_empty.jpg';

import { BOOTH_API_URL, EVENT_FOLDER, EVENT_ID } from '../constants';
import { Fab, Grid, Typography, withStyles } from '@material-ui/core';

import './Basic.css';
import axios from 'axios';

import { ImHome } from 'react-icons/im';
import { GrYoutube } from 'react-icons/gr';
import { BsFillFileEarmarkPdfFill } from 'react-icons/bs';

const styles = (theme) => ({
  bg: {
    marginTop: '-100px',
    [theme.breakpoints.down('lg')]: {
      marginTop: '-30px',
    },
  },
});
class BasicPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      result: null,
      matches: window.matchMedia('(max-width:1280px)').matches,
    };
    this.clickHome = this.clickHome.bind(this);
    this.clickHome2 = this.clickHome2.bind(this);
    this.clickDoc1 = this.clickDoc1.bind(this);
    this.clickDoc2 = this.clickDoc2.bind(this);
    this.clickVOD = this.clickVOD.bind(this);

    axios
      .get(`${BOOTH_API_URL}/booth/info?id=${this.props.match.params.id}&evt=${EVENT_ID}`, { headers: { Pragma: 'no-cache' } })
      .then((response) => {
        this.setState({ result: response.data });
      });
  }

  componentDidMount() {}

  clickHome() {
    if (this.state.result.Item.homepage) {
      window.open(this.state.result.Item.homepage);
    }
  }

  clickHome2() {
    if (this.state.result.Item.doc2) {
      window.open(this.state.result.Item.doc2);
    }
  }

  clickDoc1() {
    if (this.state.result.Item.doc1) {
      const doc1 = `https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/pdf/${this.state.result.Item.doc1}`;
      window.open(doc1);
    }
  }
  clickDoc2() {
    if (this.state.result.Item.doc2) {
      const doc2 = `https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/pdf/${this.state.result.Item.doc2}`;
      window.open(doc2);
    }
  }
  clickVOD() {
    if (!this.state.result.Item.vod) return;
    const ele = document.getElementById('video-popup');
    ele.className += ' reveal';
    const vodAddress = this.state.result.Item.vod;
    ele.innerHTML += `<div class="video-wrapper" id="video-wrapper"><iframe width="560" height="315" src="https://player.vimeo.com/video/${vodAddress}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen="" /></div>`;
  }

  closePopup() {
    const ele = document.getElementById('video-popup');
    const child = document.getElementById('video-wrapper');
    ele.removeChild(child);
    ele.className = ele.className.replace(' reveal', '');
  }

  clickLink(url) {
    window.open(url);
  }
  clickVODCustom(vodId) {
    const ele = document.getElementById('video-popup');
    ele.className += ' reveal';
    ele.innerHTML += `<div class="video-wrapper" id="video-wrapper"><iframe width="560" height="315" src="https://www.youtube.com/embed/sjkH8X1LV6A" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
    // ele.innerHTML += `<div class="video-wrapper" id="video-wrapper"><iframe width="560" height="315" src="https://www.vimeo.com/488098892" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
  }

  clickVODCustom2(vodId) {
    const ele = document.getElementById('video-popup');
    ele.className += ' reveal';
    ele.innerHTML += `<div class="video-wrapper" id="video-wrapper"><iframe width="560" height="315" src="https://hanmi.ap.panopto.com/Panopto/Pages/Embed.aspx?id=33333508-eb55-4d42-8c6f-ae4e00628d43&showbrand=false&autoplay=true&showTitle=false" frameborder="0" showbrand="false" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
    // ele.innerHTML += `<div class="video-wrapper" id="video-wrapper"><iframe width="560" height="315" src="https://www.vimeo.com/488098892" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        {this.state.result ? (
          <div className={classes.bg} style={{ position: 'relative' }}>
            {/* type === 4 경우 로고 */}
            {this.state.result.Item.type === '4' ? (
              <div className={'logo'}>
                <div
                  style={{
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>
                    <Grid item xs={9}>
                      {this.state.result.Item && this.state.result.Item.id === 'evt113_999' ? (
                        <img
                          className={'logo-img'}
                          src={`https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/logo/logo_custom.gif`}
                          alt={'booth logo'}
                          style={{ width: '100%' }}
                        />
                      ) : (
                        <img
                          className={'logo-img'}
                          src={`https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/logo/${this.state.result.Item.logo}.png`}
                          alt={'booth logo'}
                          style={{ width: '100%' }}
                        />
                      )}
                    </Grid>
                  </Grid>
                </div>
              </div>
            ) : (
              ''
            )}
            {this.state.result.Item.type === '1' ? (
              // type === 1 경우 배경이미지 (자체 부스 이미지가 있는 행사 부스)
              <div>
                <img id="main-image" src={CUSTOM_BG} alt={'background'} style={{ width: '100%' }} />
              </div>
            ) : this.state.result.Item.type === '4' ? (
              // type === 4 경우 배경이미지 (자체 부스 이미지가 없는 행사 부스)
              <div>
                <img id="main-image" src={BG_NORMAL} alt={'background'} style={{ width: '100%' }} />
              </div>
            ) : (
              // type === 3 경우 배경이미지 (자체 부스 이미지가 있는 커스텀 배치 부스)
              <div>
                <img id="main-image" src={EMPTY_BG} alt={'background'} style={{ width: '100%' }} />
              </div>
            )}
            {/* type === 1 회사별 개인 부스이미지 */}
            {this.state.result.Item.type === '1' && (
              <div>
                <img
                  src={`https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/booth/booth_${this.state.result.Item.id.replace(
                    EVENT_ID + '_',
                    '',
                  )}.png`}
                  alt={'booth'}
                  className={'custom-booth b' + this.state.result.Item.id.replace(`${EVENT_ID}_`, '')}
                />
              </div>
            )}

            {/* type === 3 회사별 개인 부스이미지 */}
            {this.state.result.Item.type === '3' && (
              <div className={'custom-booth b' + this.state.result.Item.id.replace(`${EVENT_ID}_`, '')}>
                <img
                  src={`https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/booth/booth_${this.state.result.Item.id.replace(
                    EVENT_ID + '_',
                    '',
                  )}.png`}
                  alt={'booth'}
                  style={{ width: '100%', height: '100%', position: 'relative' }}
                />

                {this.state.result.Item.doc1.length > 1 && (
                  <div className={`${this.state.result.Item.id}_pdf_1`}>
                    <Grid
                      container
                      justifyContent="center"
                      alignItems="center"
                      item
                      xs={10}
                      onClick={this.clickDoc1}
                      style={{ height: '100%', position: 'relative' }}
                    >
                      <Fab
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          height: 40,
                          width: 40,
                          backgroundColor: '#fff',
                          border: '1px solid #de3e36',
                        }}
                      >
                        <BsFillFileEarmarkPdfFill size={20} className={'gif_style'} />
                      </Fab>
                    </Grid>
                  </div>
                )}
                {this.state.result.Item.doc2.length > 1 && (
                  <div className={`${this.state.result.Item.id}_pdf_2`}>
                    <Grid
                      container
                      justifyContent="center"
                      alignItems="center"
                      item
                      xs={10}
                      onClick={this.clickDoc2}
                      style={{ height: '100%' }}
                    >
                      <Fab
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          height: 40,
                          width: 40,
                          backgroundColor: '#fff',
                          border: '2px solid #de3e36',
                        }}
                      >
                        <BsFillFileEarmarkPdfFill size={20} className={'gif_style'} />
                      </Fab>
                    </Grid>
                  </div>
                )}
                {this.state.result.Item.homepage.length > 1 && (
                  <div className={`${this.state.result.Item.id}_url`}>
                    <Grid
                      container
                      justifyContent="center"
                      alignItems="center"
                      item
                      xs={10}
                      onClick={this.clickHome}
                      style={{ height: '100%' }}
                    >
                      <Fab
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          height: 40,
                          width: 40,
                          backgroundColor: '#fff',
                          border: '2px solid #de3e36',
                        }}
                        className={'gif_style'}
                      >
                        <ImHome size={20} className={'gif_style'} />
                      </Fab>
                    </Grid>
                  </div>
                )}
                {this.state.result.Item.id === 'evt113_008' && this.state.result.Item.vod.length > 1 ? (
                  <div className={`${this.state.result.Item.id}_vod`}>
                    <Grid
                      container
                      justifyContent="center"
                      alignItems="center"
                      item
                      xs={10}
                      onClick={this.clickVODCustom2}
                      style={{ height: '100%' }}
                    >
                      <Fab
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          height: 40,
                          width: 40,
                          backgroundColor: '#fff',
                          border: '2px solid #de3e36',
                        }}
                        className={'gif_style'}
                      >
                        <GrYoutube size={20} className={'gif_style'} />
                      </Fab>
                    </Grid>
                  </div>
                ) : (
                  <div className={`${this.state.result.Item.id}_vod`}>
                    <Grid
                      container
                      justifyContent="center"
                      alignItems="center"
                      item
                      xs={10}
                      onClick={this.clickVOD}
                      style={{ height: '100%' }}
                    >
                      <Fab
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          height: 40,
                          width: 40,
                          backgroundColor: '#fff',
                          border: '2px solid #de3e36',
                        }}
                        className={'gif_style'}
                      >
                        <GrYoutube size={20} className={'gif_style'} />
                      </Fab>
                    </Grid>
                  </div>
                )}
              </div>
            )}

            {this.state.result.Item.type === '1' || this.state.result.Item.type === '4' ? (
              <>
                <div className={'panel-position'}>
                  <Grid container justifyContent="center" alignItems="center" className={'panel-board'}>
                    <Grid container justifyContent="center" alignItems="center" style={{ height: '80%' }}>
                      {this.state.result.Item.homepage.length > 1 && (
                        <Grid
                          container
                          justifyContent="center"
                          alignItems="center"
                          item
                          xs={10}
                          className={'panel-content'}
                          onClick={this.clickHome}
                        >
                          {this.state.matches ? (
                            <ImHome size={20} style={{ color: '#de3e36' }} />
                          ) : (
                            <Typography style={{ color: '#193C6E', fontSize: 'small' }}>WEB LINK</Typography>
                          )}
                        </Grid>
                      )}

                      {this.state.result.Item.doc1.length > 1 && (
                        <Grid
                          container
                          justifyContent="center"
                          alignItems="center"
                          item
                          xs={10}
                          className={'panel-content'}
                          onClick={this.clickDoc1}
                        >
                          {this.state.matches ? (
                            <BsFillFileEarmarkPdfFill size={20} style={{ color: '#de3e36' }} />
                          ) : (
                            <Typography style={{ color: '#193C6E', fontSize: 'small' }}>BROCHURE 1</Typography>
                          )}
                        </Grid>
                      )}

                      {this.state.result.Item.doc2.length > 1 && (
                        <Grid
                          container
                          justifyContent="center"
                          alignItems="center"
                          item
                          xs={10}
                          className={'panel-content'}
                          onClick={this.clickDoc2}
                        >
                          {this.state.matches ? (
                            <BsFillFileEarmarkPdfFill size={20} style={{ color: '#de3e36' }} />
                          ) : (
                            <Typography style={{ color: '#193C6E', fontSize: 'small' }}>BROCHURE 2</Typography>
                          )}
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </div>
                {this.state.result.Item.type === '4' && this.state.result.Item.vod > 1 && <div onClick={this.clickVOD} className={'a4'} />}
                {this.state.result.Item.type === '1' && this.state.result.Item.vod > 1 && (
                  <div onClick={this.clickVOD} className={'type_1_vod'} />
                )}
                {this.state.result.Item.id === 'evt113_014' && 1 && <div onClick={this.clickVODCustom} className={'a4'} />}
              </>
            ) : (
              ''
            )}
          </div>
        ) : (
          ''
        )}
        <div id="video-popup" className="video-popup" onClick={this.closePopup}>
          <div className="video-popup-closer" />
        </div>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(BasicPage);
